import axios from '@axios';
import { ErrorMessage } from '@/libs/Error';

export default class SlsTipoEnderecoClient {
  constructor() {
    this.api = axios;
    this.error = new ErrorMessage();
  }

  async getItems(queries = {}) {
    try {
      const { data } = await this.api.get('/tipoendereco');
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as TipoEndereco');
    }
  }

  async index(queries = {}) {
    try {
      return await this.api.get('/tipoendereco', { params: queries });
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as TipoEndereco');
    }
  }

  async store(data) {
    try {
      const { data: response } = await this.api.post('/tipoendereco', data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao criar as TipoEndereco');
    }
  }

  async show(id) {
    try {
      const { data } = await this.api.get(`/tipoendereco/${id}`);
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao buscar a TipoEndereco');
    }
  }

  async update(id, data) {
    try {
      const { data: response } = await this.api.put(`/tipoendereco/${id}`, data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao atualizar a TipoEndereco');
    }
  }

  async destroy(id) {
    try {
      const { data: response } = await this.api.delete(`/tipoendereco/${id}`);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao deletar a TipoEndereco');
    }
  }
}
